export default "__VITE_ASSET__BsJ0MOxv__"